import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Compagnia } from '../models/compagnia';
import { ResourcefulService } from './resourcefulService';



@Injectable({
  providedIn: 'root'
})
export class CompagniaService extends ResourcefulService<Compagnia>{
  constructor(private httpClient: HttpClient) {
    super(httpClient, Compagnia);
  }
}
